import React, { useEffect, useState, useRef } from "react";
import "./index.scss";
import { connect } from 'react-redux'
import { getAPi } from '../../api/api'
import HuntOptions from "./huntOptions";
import Loader from "../../reusableComponents/loader/Loader";
import HuntDetails from "./huntDetails";
import SideDrawerMenu from '../../reusableComponents/sideDrawerMenu/sideDrawerMenu';
import { fetchGetUnitDetails } from '../../../../action/huntPlanner-unitdetails-actions'
import { stopLoading } from "../../../../action/huntPlanner-load-spinner-action";
import { huntPlannerActiveOtions } from '../../../../action/huntplanner-selected-options';
import { fetchGetHuntUnitList } from '../../../../action/huntPlanner-api-actions';
import { fetchGetHuntList } from '../../../../action/huntPlanner-api-actions';
import { removeLayers } from '../../huntplanner-layer-render/renderlayerFunction';
import { fetchGetFilterValues } from '../../../../action/huntPlanner-api-actions';
import { multiTileHuntLayers } from "../../huntplanner-layer-render/renderlayerFunction";
import UpgradeButton from "./upgrade-button";
import LockIcon from '../../../../../asset/lock.png'
import Locktext from "./locktext";
// import EllipsisText from "../../reusableComponents/tooltip";

const UnitDetails = (props) => {
  const [fetchUnitData, setFetchUnitData] = useState()
  const [hideUnits, setHideUnits] = useState(false)
  const [spinLoader, setSpinLoader] = useState(true)
  const [huntData, sethuntData] = useState()
  const [openHunt, setOpenHunt] = useState(false)
  const [showMore, setShowMore] = useState(false)

  const [isOverflowing, setIsOverflowing] = useState(false);
  const textRef = useRef(null);

  useEffect(() => {
    if (textRef.current) {
      setIsOverflowing(textRef.current.scrollHeight > 40);
    }
  }, [fetchUnitData?.description]);

  useEffect(() => {
    if (props.from == 'map') {
      setFetchUnitData(props.unitData)
      setSpinLoader(false)
      props.stopLoading()
    } else {
      fetchUnitdata(props.huntPlannerSelectedOtions)
    }
  }, [])

  useEffect(() => {
    if (props.location == 'menu') {
      props.renderLayerUnit(true)
    }
  }, []);

  let closeUnit = () => {
    props.closeTheCard()
  }


  let closeUnitFromHunt = () => {
    sethuntData(false); // Toggle details
    props.closeTheCard()

  }

  let onHide = () => {
    setHideUnits(!hideUnits)
  }

  let fetchUnitdata = (payloadData) => {
    let payload = {
      ...payloadData,
      unitName: props.unitData.unitName
    };
    let unitName = props.unitData.unitName
    if (unitName) {
      props.fetchGetUnitDetails(payload)
        ?.then((res) => {
          setFetchUnitData(res)
          setSpinLoader(false)
        })
        .catch((error) => {
          // setLoadSpinner(false)
          console.error('API Error:', error);
        });
    }
  }

  const formatKey = (key) => {
    return key
      .replace(/([a-z])([A-Z])/g, "$1 $2") // Add space before capital letters
      .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize first letter of each word
  };

  let onCLickOnHuntsItems = (huntData) => {
    sethuntData(huntData)
    setOpenHunt(true)
  }

  return (
    <>
      <div className="unit-details-container">
        <div className="back-arrow-div">
          <img onClick={closeUnit} src={require('../../../../../asset/Close-X_Thin_F2F2F2_SVG.svg')} className="back-arrow-style" style={{ height: 20 }}></img>
        </div>

        {true &&
          <div className="unit-details-container-two">

            <div className="unit-details-header">
              <h3 className="unit-title">Unit: {props.unitData.geoName || props.unitData.unitName}</h3>
            </div>

            <div className="unit-metrics">
              <div className="stat">
                <Locktext
                  LockIcon={LockIcon}
                  text={props.unitData.unitScore}
                  showText={props.huntPlannerFilterOptions?.huntResearch}
                />
                <div className="progress">
                  <div
                    className={`progress-bar ${props.unitData.unitScore <= 33 ? 'red' : props.unitData.unitScore <= 66 ? 'yellow' : 'green'}`}
                    style={{ width: `${props.unitData.unitScore ?? 0}%` }}
                  ></div>
                </div>
                <p className="label font-style-roboto-normal text-color-333333">Unit Score</p>
              </div>

              <div className="partition-line"></div>

              <div className="stat">
                <Locktext
                  LockIcon={LockIcon}
                  text={(props.unitData.trophy ? props.unitData.trophy + '"' : "-")}
                  showText={props.huntPlannerFilterOptions?.huntResearch}
                />
                <div className="progress">
                  <div
                    className={`progress-bar ${props.unitData?.trophy <= 33 ? 'red' : props.unitData?.trophy <= 66 ? 'yellow' : 'green'}`}
                    style={{ width: `${props.unitData?.trophy ?? 0}%` }}
                  ></div>
                </div>
                <p className="label font-style-roboto-normal text-color-333333">Trophy</p>
              </div>

              <div className="partition-line"></div>

              <div className="stat">
                <div className='stat' style={{ width: '100%', height: 20, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <span className="metric-value font-style-roboto" >
                    {props.unitData.publicLand !== undefined ? `${props.unitData.publicLand}%` : "-"}
                  </span>
                </div>
                <div className="progress">
                  <div
                    className={`progress-bar ${props.unitData?.publicLand <= 33 ? 'red' : props.unitData?.publicLand <= 66 ? 'yellow' : 'green'}`}
                    style={{ width: `${props.unitData?.publicLand ?? 0}%` }}
                  ></div>
                </div>
                <p className="label font-style-roboto-normal text-color-333333">Public Land</p>
              </div>
            </div>
          </div>
        }
      </div>

      {true &&
        <div className="unit-card-item">
          {props.huntPlannerFilterOptions?.huntResearch ?
            <div className="ht-unit-score-container" style={{ width: '100%' }}>
              <div className="ht-unit-score-card">
                <div className="ht-unit-score-header">
                  <span className="font-style-roboto-normal-12em text-color-535151">Unit Score</span>
                  <div>
                    <span className="ht-unit-score-value">{props.unitData.unitScore}</span>
                    <span className="ht-unit-score-total">/100</span>
                  </div>
                </div>
                <div className="ht-score-list">
                  {hideUnits && fetchUnitData?.unitScores && Object.entries(fetchUnitData.unitScores)
                    .filter(([key, value]) => typeof value === "number" && key != "huntScoreId") // Filter out non-numeric values
                    .map(([label, value], index) => {
                      return (
                        <div key={index} className="ht-item" >
                          <div className="ht-label">
                            {formatKey(label)}
                            {/* <EllipsisText text={formatKey(label)}></EllipsisText> */}
                          </div>
                          <div className="ht-container">
                            <div
                              className={`ht-progress-bar ${value < 33 ? "bg-red" : value < 66 ? 'bg-yellow ' : "bg-green"}`}
                              style={{ width: `${value < 5 ? value == 0 ? 0 : 5 : value}%` }}
                            ></div>
                          </div>
                          <div className="ht-value">
                            <p className="ht-value-p"> {value} </p>
                          </div>
                        </div>
                      );
                    })}
                </div>
                <div className="up-down-arrow-div" onClick={() => onHide()}>
                  <div className={hideUnits ? 'down-chevron' : 'up-chevron'}></div>
                </div>
              </div>
            </div>
            :
            <UpgradeButton className={'upgrade-button-style'}></UpgradeButton>
          }

          {fetchUnitData?.description &&
            <div className="show-more-description">
              <div className="show-more-description-text font-style-arial-normal"
                ref={textRef}
                style={{ height: !showMore ? '40px' : '' }}
              >{fetchUnitData?.description} </div>
              {/* <p className="show-more-button" onClick={() => { setShowMore(!showMore) }}>{showMore ? 'Show less' : 'Show more'}</p> */}

              {isOverflowing && (
                <p className="show-more-button" onClick={() => setShowMore(!showMore)}>
                  {showMore ? "Show less" : "Show more"}
                </p>
              )}
            </div>
          }

          {fetchUnitData &&
            <div className="ht-unit-score-container" style={{ width: '100%', minHeight: 220 }}>
              <HuntOptions
                UnitData={fetchUnitData}
                onCLickOnHuntsItems={(val) => onCLickOnHuntsItems(val)}
              ></HuntOptions>
            </div>
          }

          {spinLoader && <Loader position={'absolute'} left={'42%'} width={'30px'}></Loader>}

          {openHunt && huntData &&
            <SideDrawerMenu
              width={'46.86vw'}
              onClick={(e) => {
                e.stopPropagation(); // Prevent event from bubbling up to unit-card
              }}
            >
              <HuntDetails
                unitData={huntData}
                payload={props.huntPlannerSelectedOtions}
                unitDetailsResponse={props.unitDetailsResponse}
                unitDetails={props.unitData}
                unitNameRelatedData={props.unitData}
                from={props.from}
                closeTheCard={() => {
                  sethuntData(false); // Toggle details
                }}
                closeTheUnit={closeUnitFromHunt}
              />
            </SideDrawerMenu>
          }
        </div>
      }
    </>
  );
};

const mapStateToProps = state => ({
  auth: state.auth,
  huntPlannerSelectedOtions: state.huntPlannerSelectedOtions,
  huntPlannerLoader: state.huntPlannerLoader,
  huntplannerStatesData: state.huntplannerStatesData,
  huntPlannerSelectedOtions: state.huntPlannerSelectedOtions,
  huntplannerMapReference: typeof state.huntplannerMapReference === 'function' ? state.huntplannerMapReference() : null,
  currentSubscription: state.currentSubscription,
  huntPlannerFilterOptions: state.huntPlannerFilterOptions,
})

const mapDispatchToProps = dispatch => ({
  fetchGetUnitDetails: (payload) => dispatch(fetchGetUnitDetails(payload)),
  stopLoading: () => dispatch(stopLoading()),
  huntPlannerActiveOtions: (payload) => dispatch(huntPlannerActiveOtions(payload)),
  fetchGetHuntUnitList: (payload) => dispatch(fetchGetHuntUnitList(payload)),
  fetchGetHuntList: (payload) => dispatch(fetchGetHuntList(payload)),
  fetchGetFilterValues: (payload) => dispatch(fetchGetFilterValues(payload))
})

export default connect(mapStateToProps, mapDispatchToProps)(UnitDetails)